module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_23.18197261.jpg";